import { KeyboardEventHandler } from 'react';
import { CallToAction } from './model.ts';

export function Cta({
	url,
	target,
	ariaLabel,
	dataLinkEvent,
	label,
	onKeyDown,
}: Partial<CallToAction> & {
	onKeyDown?: KeyboardEventHandler<HTMLAnchorElement>;
}) {
	return (
		<a
			data-final-url
			className="blk-ac-tertiary-button default-icon"
			href={url}
			target={target}
			{...(onKeyDown && {
				onKeyDown,
			})}
			{...(ariaLabel && {
				'aria-label': ariaLabel,
			})}
			{...(dataLinkEvent && {
				'data-link-event': dataLinkEvent,
			})}
		>
			{label}
		</a>
	);
}
